import { render, staticRenderFns } from "./InstagramSlider.vue?vue&type=template&id=0e80b100&scoped=true&"
import script from "./InstagramSlider.vue?vue&type=script&lang=js&"
export * from "./InstagramSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e80b100",
  null
  
)

export default component.exports